var _rect, _rect2, _rect3, _rect4, _path, _rect5, _path2, _rect6, _rect7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkTrainingRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 68,
    height: 68,
    rx: 18,
    fill: "url(#paint0_linear)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 24,
    width: 44,
    height: 28,
    rx: 5,
    fill: "#3F454B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 28,
    width: 34,
    height: 20,
    rx: 1.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 31,
    width: 28,
    height: 14,
    fill: "#32BDB8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 38.2L37.2 44.4L50.5 31.1L54 34.6L37.2 51.4L27.5 41.7L31 38.2Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 59,
    width: 29,
    height: 4,
    rx: 1,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 58L65 61L58 64V58Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 58,
    width: 10,
    height: 6,
    rx: 3,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 35,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#596069"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 14,
    y1: 11,
    x2: 66,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24AFAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkTrainingRegister);
export default __webpack_public_path__ + "static/media/bookmark_training_register.5f59cc97ccf9e9bc73a8c9a42f867640.svg";
export { ForwardRef as ReactComponent };